/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EtlTenant = {
    code: string;
    /**
     * The company's MySQL schema, which DMS writes as the bronze tenant prefix
     */
    tenancy: string;
    /**
     * The status the reconciler last reported for the company
     */
    etlStatus: EtlTenant.etlStatus | null;
    /**
     * When that status was reported
     */
    etlStatusAt: string | null;
};

export namespace EtlTenant {

    /**
     * The status the reconciler last reported for the company
     */
    export enum etlStatus {
        REPLICATING = 'replicating',
        LOADING = 'loading',
        STAGING = 'staging',
        SILVER = 'silver',
        GOLD = 'gold',
        FAILED = 'failed',
        PENDING = 'pending',
        REMOVING = 'removing',
        REMOVED = 'removed',
    }


}

